import styled, {css} from 'styled-components'

const Div = styled.div`
  width: 100%;
  color: black;
  background-color: #7289da;
  font-size: 2em;
  font-weight: 800;
  padding: 5px 0px;
`;

export default Div;
